// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Rpyq forms_component__2VjjL","box":"Radio_box__3Iuf7","inverted":"Radio_inverted__FRDQ0","labelText":"Radio_labelText__IksgL","label":"Radio_label__1b8G2"};